import _ from 'lodash';
import Vue from 'vue';

import listItemUtils from '@/services/propertyComparables/listItem.utils.js';
import comparableSortingUtils from '@/services/propertyComparables/comparableSorting.utils';

import paramListConsts from '@/consts/paramList.const';
import comparableOrderingUtils from '@/services/common/comparableOrdering.utils';
import statusConst from '@/consts/status.const.js';
import unitsConst from '@/consts/unit.const.js';
import comparableUtils from '@/services/propertyComparables/comparable.utils.js';
import propertyUtils from '@/services/property/property.utils.js';
import researchUtils from '@/services/research/research.utils.js';
import Deferred from '@/services/common/deferred.utils.js';
import Console from '@/shared/console';
import genericTabConst from '@/consts/genericTab.const.js';
import getComparablesModeConst from '@/consts/getComparablesMode.const.js';
import popUpUtils from '@/services/propertyComparables/popUp.utils.js';
import pixUtils from '@/services/common/pix.utils.js';
import genericTabsUtils from '@/services/genericConfig/genericTabs.utils.js';
import mapUtils from '@/services/common/map.utils.js';
import genericFormService from '@/services/genericConfig/genericForm.utils.js';
import comparablesCommonState from './comparablesCommonState.js';
import regexConst from '@/consts/regex.const.js';
import modeConst from '@/consts/mode.const.js';
import locationFilterConst from '@/consts/locationFilter.const.js';
import comparableSetConst from '@/consts/comparableSet.const.js';
import comparableSubTabConst from '@/consts/comparableSubTab.const';
import pixAxios from '@/axios/pixAxios.js';
import pixAxiosSyncRequests from '@/axios/pixAxiosSyncRequests.js';
import moment from 'moment';
import formIdConst from '@/consts/formId.const.js';
import pixIncomeExpensesFilters from '../../../components/pix/pixGenericFilters/pixIncomeExpensesFilters';
import propertyUseConst from '@/consts/propertyUse.const.js';
import fullInstanceConst from '@/consts/fullInstance.const';
import appIdParameter from '@/consts/appIdParameterConfig.const.js';
import marketRentUtils from '@/shared/marketRentUtils.js';
import documentUtils from '@/services/document/document.utils.js';
import webAnalyticsUtils from '@/utils/webAnalytics.utils';
import webAnalyticsEventsConst from '@/consts/webAnalyticsEvents.const';
import typeInfoConfiguration from '@/consts/typeInfoConfiguration.const.js';
const createInitialState = () =>
  _.cloneDeep({
    selectedTab: '',
    operationTypeParams: [],
    [genericTabConst.LEASE_COMPS]: {
      ...comparablesCommonState.getCommonAttributesToStore(),
      profilePage: 0,
      filters: [],
      selectedMLA: null,
      goToCommentSection: null,
      staticColumnsConfig: null,
      filtersStructure: null,
      mapConfigIsLoaded: false,
      newLeaseComparableID: null,
    },
    [genericTabConst.SALES_COMPS]: {
      ...comparablesCommonState.getCommonAttributesToStore(),
      profilePage: 0,
      filters: [],
      goToCommentSection: null,
      staticColumnsConfig: null,
      filtersStructure: null,
      mapConfigIsLoaded: false,
    },
    [genericTabConst.LAND_COMPS]: {
      ...comparablesCommonState.getCommonAttributesToStore(),
      profilePage: 0,
      filters: [],
      goToCommentSection: null,
      staticColumnsConfig: null,
      filtersStructure: null,
      mapConfigIsLoaded: false,
    },
    [genericTabConst.IE_COMPS]: {
      ...comparablesCommonState.getCommonAttributesToStore(),
      profilePage: 0,
      filters: [],
      tableConfig: [],
      filtersStructure: null,
      mapConfigIsLoaded: false,
      TwelveMonth: true,
    },
    [genericTabConst.RENT_SURVEY_COMPS]: {
      ...comparablesCommonState.getCommonAttributesToStore(),
      profilePage: 0,
      filters: [],
      tableConfig: [],
      filtersStructure: null,
      mapConfigIsLoaded: false,
      selectedMLA: null,
    },
    //TODO GET THIS TO RESEARCH MODULE
    [genericTabConst.LEASE_RESEARCH]: {
      ...comparablesCommonState.getCommonAttributesToStore(),
      ...comparablesCommonState.getCommonResearchAttributesToStore(),
      profilePage: 0,
      filters: [],
      goToCommentSection: null,
      staticColumnsConfig: null,
      filtersStructure: null,
      mapConfigIsLoaded: false,
      newLeaseComparableID: null,
    },
    [genericTabConst.SALES_RESEARCH]: {
      ...comparablesCommonState.getCommonAttributesToStore(),
      ...comparablesCommonState.getCommonResearchAttributesToStore(),
      profilePage: 0,
      filters: [],
      goToCommentSection: null,
      staticColumnsConfig: null,
      filtersStructure: null,
      mapConfigIsLoaded: false,
    },
    [genericTabConst.LAND_RESEARCH]: {
      ...comparablesCommonState.getCommonAttributesToStore(),
      ...comparablesCommonState.getCommonResearchAttributesToStore(),
      profilePage: 0,
      filters: [],
      goToCommentSection: null,
      staticColumnsConfig: null,
      filtersStructure: null,
      mapConfigIsLoaded: false,
    },
    modalForms: {
      openModal: '',
      newCompForm: null,
      newLeaseForm: null,
      newLandForm: null,
      newLocation: undefined,
    },
    modalType: '',
    modalMlaGrid: '',
    status: {
      newCompForm: statusConst.PENDING,
      newLeaseForm: statusConst.PENDING,
      newLandForm: statusConst.PENDING,
    },
    configuration: {
      [typeInfoConfiguration.LeaseList]: null, // Lease result list
      [typeInfoConfiguration.LeasePopup]: null, // Lease popup window
      [typeInfoConfiguration.LandList]: null, // Land result list
      [typeInfoConfiguration.LandPopup]: null, // Land popup window
      [typeInfoConfiguration.SalesList]: null, // Sale result list
      [typeInfoConfiguration.SalesPopUp]: null, // Sale popup window
      [typeInfoConfiguration.ComercialLeasePopupParent]: null, // Lease Commercial Popup window – Parent section
      [typeInfoConfiguration.ComercialLeasePopupChild]: null, // Lease Commercial Popup window – Child section
      [typeInfoConfiguration.ComercialLeaseList]: null, // Lease result list - same as typeinfo 1 - for comps with parentInfo (commercialLease - R2)
      [typeInfoConfiguration.IEList]: null, // I&E result list
      [typeInfoConfiguration.IEPopup]: null, // I&E popup window
    },

    // State - opciones - property
    compListSorting: null,
    // State - opciones - tabla
    compTableSorting: null,
    // State - opciones - research busqueda
    researchComparablesSortingList: null,
    // State - opciones - research cesta
    researchBasketSortingList: null,
    // State - direccion - property
    comparablesSortingDirection: 'DES',
    // State - campo - property
    comparablesSortingField: null,

    genericComparable: null,

    savedComparableProfile: null,

    baskets: {
      status: statusConst.PENDING,
      promise: null,
    },
  });

const comparablesModule = {
  namespaced: true,

  state: createInitialState(),

  actions: {
    resetState({ commit }) {
      commit('resetState');
    },

    /**
     * TODO, OJO
     * @param type
     * METODO para arreglar rapidamente el error de mostrar o no el comparable que haz editado
     * y se este ordenando por XXX campo en el profile
     * https://dev.azure.com/JLL-Applications/GLOBAL-PIX/_workitems/edit/1692386
     */
    setActivePageToSaveComparable({ state, getters }, type) {
      if (state.savedComparableProfile) {
        const orderComparablesList = getters.getOrderedSelectedComparables(type);
        state[type].profilePage = orderComparablesList.findIndex((comp) => comp.id === state.savedComparableProfile.id) + 1;
      }
    },

    /**
     *
     * @param comparable
     * https://dev.azure.com/JLL-Applications/GLOBAL-PIX/_workitems/edit/1692386
     */
    setSavedComparableProfile({ commit }, comparable) {
      commit('setSavedComparableProfile', comparable);
    },

    setFilterValue({ commit, state }, { InternalField, value, property, selectedTab }) {
      const filter = state[selectedTab].filters.find(({ InternalField: filterInternalField }) => filterInternalField === InternalField);
      if (filter) {
        if (!filter.hasOwnProperty(property)) {
          filter[property] = filter.DefaultValue;
        }
        commit('setFilterValue', { filter, value, property });
      }
    },

    setLastSelectedTwelveMonthFlagFilter({ commit, state, getters }, { selectedTab }) {
      const value = getters.getTwelveMonthFlagFilter(selectedTab);
      commit('setLastSelectedTwelveMonthFlagFilter', { selectedTab, value });
    },

    toggleFilterActive({ commit }, { name, active }) {
      commit(`toggleFilter${name}Active`, !active);
    },

    // TODO check for async issues (user moves map and hits show more => race condition, talk about how to solve that)
    async fetchComparablesWithBasket({ state, commit, getters, dispatch, rootGetters }, { typeCall = getComparablesModeConst.RESET_PAGINATION, selectedTab }) {
      if (state[selectedTab].filtersStructure) {
        let skip, take;
        const isReload = typeCall === getComparablesModeConst.RELOAD;
        const isResetPagination = typeCall === getComparablesModeConst.RESET_PAGINATION;
        const isShowMore = typeCall === getComparablesModeConst.SHOWMORE;

        try {
          if (isShowMore) {
            skip = state[selectedTab].numberOfSkips * state[selectedTab].pageSize;
            take = state[selectedTab].pageSize;
            state[selectedTab].numberOfSkips += 1;
          } else if (isReload) {
            skip = 0;
            take = state[selectedTab].pageSize * state[selectedTab].numberOfSkips;
            commit('clearPagination', selectedTab);
            commit('setComparables', { tab: selectedTab, comparables: [] });
          } else if (isResetPagination) {
            skip = 0;
            take = state[selectedTab].pageSize;
            state[selectedTab].numberOfSkips = 1;
            commit('clearPagination', selectedTab);
            commit('setComparables', { tab: selectedTab, comparables: [] });
          }

          const isFreeText = state[selectedTab].filters?.find(({ InternalField }) => InternalField === 'Location')?.SearchType?.ValueCode === locationFilterConst.FREE_TEXT;
          // On free text searchs any shape of the map is removed
          if (isFreeText && state[selectedTab].filters?.find(({ InternalField }) => InternalField === 'Location')?.FreeText) {
            if (rootGetters['pixMapModule/getCircles'].length) {
              dispatch('setAutomaticSearchOnShapeChange', { value: false, selectedTab });
              dispatch(
                'pixMapModule/setCircles',
                {
                  mapId: `comparable-map-${selectedTab}`,
                  circles: [],
                },
                { root: true }
              );
            }
            if (rootGetters['pixMapModule/getPolygons'].length) {
              dispatch('setAutomaticSearchOnShapeChange', { value: false, selectedTab });
              dispatch(
                'pixMapModule/setPolygons',
                {
                  mapId: `comparable-map-${selectedTab}`,
                  polygons: [],
                },
                { root: true }
              );
            }

            if (rootGetters['pixMapModule/getDataLayers'].length) {
              dispatch('setAutomaticSearchOnShapeChange', { value: false, selectedTab });
              dispatch(
                'pixMapModule/setDataLayers',
                {
                  mapId: `comparable-map-${selectedTab}`,
                  dataLayers: [],
                },
                { root: true }
              );
            }
          } else {
            dispatch('fetchComparablesBaskets', { selectedTab });
          }

          dispatch(
            'pixMapModule/setMarkers',
            {
              mapId: `comparable-map-${selectedTab}`,
              markers: [],
            },
            { root: true }
          );

          /** Cuando el usuario filtre por "Only 12 month", se filtrará el listado de comparables, eliminando los que contengan IncomeExpenses12Month = null.
           * El listado se filtra desde front al obtener la respuesta, ya que en mongo el objeto del comparable ya no dispone de la variable 'IncomeExpenses.TwelveMonthFlag',
           * por lo que ya no se enviará este filtro.
           *
           * UPDATE:
           * https://dev.azure.com/JLL-Applications/GLOBAL-PIX/_workitems/edit/1642231
           * Se quita el filtrado ahora el equipo de back se encargara de controlar este filtro.
           */

          const filters = JSON.parse(JSON.stringify(getters.getComparablesFilter(selectedTab)));
          const body = { ...filters, skip, take };

          if (body.polygon || body.circle || body.SearchText) {
            commit('setComparablesStatus', { status: statusConst.LOADING, tab: selectedTab });

            await pixAxiosSyncRequests
              .post('api/Comparables/GetComparablesWithBasket', body, {
                requestId: `get-comparables-with-basket-${selectedTab}`,
              })
              .then((response) => {
                let comparables = selectedTab === genericTabConst.IE_COMPS && getters.getTwelveMonthFlagFilter(selectedTab) ? response.data.Comparables.filter((e) => e.IncomeExpenses12Month) : response.data.Comparables;
                const comparablesFromCallWithoutSummation =
                  selectedTab === genericTabConst.IE_COMPS && getters.getTwelveMonthFlagFilter(selectedTab) ? response.data.Comparables.filter((e) => e.IncomeExpenses12Month) : response.data.Comparables;

                if (isShowMore && state[selectedTab].comparables && state[selectedTab].comparables.length > 0) {
                  comparables = [...state[selectedTab].comparables, ...comparables];
                }

                // TODO this is mutating the state in an action
                state[selectedTab].showMore = response.data.Metadata?.Count;
                commit('setComparables', { tab: selectedTab, comparables });
                commit('setComparablesWithoutSummation', { tab: selectedTab, comparablesFromCallWithoutSummation });
                commit('setComparablesStatus', { status: statusConst.SUCCESS, tab: selectedTab });
              })
              .catch((error) => {
                commit('setComparablesStatus', { status: statusConst.FAIL, tab: selectedTab });
              });
          } else {
            dispatch('toastModule/error', "You haven't selected polygon, radius nor a free text search ", { root: true });
          }
        } catch (err) {
          if (!err?.canceled) {
            Console.error(err);
            commit('setComparablesStatus', { status: statusConst.FAIL, tab: selectedTab });
          }
        }
      }
    },

    async blockingChangeComparableStatus({ dispatch }, payload) {
      dispatch('loadingOverlayModule/setIsLoading', true, { root: true });
      const newStatus = await dispatch('changeComparableStatus', payload);
      await dispatch('fetchComparablesWithBasket', {
        typeCall: getComparablesModeConst.RELOAD,
        selectedTab: payload.selectedTab,
      });
      dispatch('loadingOverlayModule/setIsLoading', false, { root: true });

      return newStatus;
    },

    // TODO check for async issues
    async changeComparableStatus({ state, commit, dispatch, getters }, { comparable, change, addMlaValueToBasketComparable, mlaFromTable, selectedTab, onlyUpdateTheComparableWithoutChangingTheStatus /* Sorry */ }) {
      let newStatus = null;
      if (onlyUpdateTheComparableWithoutChangingTheStatus) {
        newStatus = comparable?.ComparableStatus;
      } else {
        newStatus = comparable?.ComparableStatus === change ? null : change;
      }

      try {
        dispatch('setRelativesToggleStatus', { comparable, change, tab: selectedTab });
        if (newStatus !== null) {
          const comp = _.cloneDeep({ ...comparable });

          comp.ComparableStatus = newStatus;

          comp.BasketId = state[selectedTab].basket.id;

          if (!comparable.ComparableStatus) {
            comp.id = crypto.randomUUID();
            comp.SourceId = comparable.id;
            comp.OriginalSourceId = comparable.OriginalSourceId || comparable.id;
          }
          if (comp.ParentInfo) {
            comp.ParentInfo.SourceId = comp.ParentInfo.id;
            comp.ParentInfo.OriginalSourceId = comp.ParentInfo.OriginalSourceId ?? comp.ParentInfo.id;
            comp.ParentInfo.Id = comp.ParentInfo.id;
            comp.ParentInfo.RowId = crypto.randomUUID();
          }

          const tabs = [genericTabConst.LEASE_COMPS, genericTabConst.RENT_SURVEY_COMPS, genericTabConst.SALES_COMPS, genericTabConst.LAND_COMPS];

          if (tabs.some((tab) => tab === selectedTab) && state[selectedTab]?.selectedMLA && addMlaValueToBasketComparable) {
            comparableUtils.setFieldValueInFeatures(comp, 'ComparableMLA', state[selectedTab]?.selectedMLA?.join(';'), 'MLA', 'string');
          }

          if (mlaFromTable) {
            comparableUtils.setFieldValueInFeatures(comp, 'ComparableMLA', mlaFromTable?.join(';'), 'MLA', 'string');
          }

          if (selectedTab === genericTabConst.IE_COMPS) {
            comparableUtils.setFieldValueInFeatures(comp, 'SavedBasketCompWithIncomeExpenses12Month', getters.getTwelveMonthFlagFilter(selectedTab), '', 'boolean');
          }

          const { data: newComparable } = await pixAxios.post('api/Comparables/InsertComparableInBasket', comp);

          await dispatch('updateRelativeParentsFromGlobalCollection', {
            tab: selectedTab,
            comparable: newComparable,
            basketId: newComparable.BasketId,
            basketName: newComparable.BasketName,
          });

          let hasComparable;
          state[selectedTab].basket.Comparables.forEach((c) => {
            if (c.id === newComparable.id) {
              commit('updateBasketComparable', { tab: selectedTab, comparable: newComparable });
              hasComparable = true;
            }
          });

          if (!hasComparable) {
            commit('setComparablesBasket', {
              tab: selectedTab,
              comparables: [...state[selectedTab].basket.Comparables, newComparable],
            });
          }
        } else {
          const { data: isDeleted } = await pixAxios.delete(`api/Comparables/DeleteComparableFromBasket?id=${comparable.id}`);
          let newPage = null;

          if (isDeleted) {
            dispatch('updateRelativeParentsFromGlobalCollection', {
              tab: selectedTab,
              comparable,
              basketId: null,
              basketName: null,
            });

            commit('setComparablesBasket', {
              tab: selectedTab,
              comparables: state[selectedTab].basket.Comparables.filter((comp) => comparable.id !== comp.id),
            });
            // When we deselect a comp from basket we need to move to the previous page (meaning that if we were on the third selected comp we should move to the second one)
            const currentPage = getters.getSelectedTabProfilePage(selectedTab) - 1;
            newPage = currentPage > 0 ? currentPage : 1;
          }

          if (getters.getSelectedComparableSetData(selectedTab)?.selectedComparableSet !== comparableSetConst.ALL) {
            dispatch('setProfilePage', { selectedTab, page: newPage });
          }
        }
      } catch (err) {
        Console.log(err);
      } finally {
        dispatch('deleteRelativesToggleStatus', { comparable, tab: selectedTab });
      }
      return newStatus;
    },

    setRelativesToggleStatus({ commit, getters }, { comparable, change, tab }) {
      const globalCollectionComps = getters.getComparables(tab).filter((globalCollectionComp) => comparableUtils.isRelative({ maybeOriginal: globalCollectionComp, maybeDerived: comparable }));
      globalCollectionComps.forEach((globalCollectionComp) => {
        commit('setToggleStatus', { id: globalCollectionComp.id, change, tab });
      });

      const relativeComp = getters.getBasket(tab).Comparables.find((basketComp) => comparableUtils.isRelative({ maybeOriginal: comparable, maybeDerived: basketComp }));
      if (relativeComp) {
        commit('setToggleStatus', { id: relativeComp.id, change, tab });
      }

      commit('setToggleStatus', { id: comparable.id, change, tab });
    },

    deleteRelativesToggleStatus({ commit, getters }, { comparable, tab }) {
      const globalCollectionComps = getters.getComparables(tab).filter((globalCollectionComp) => comparableUtils.isRelative({ maybeOriginal: globalCollectionComp, maybeDerived: comparable }));
      globalCollectionComps.forEach((globalCollectionComp) => {
        commit('deleteToggleStatus', { id: globalCollectionComp.id, tab });
      });

      const relativeComp = getters.getBasket(tab).Comparables.find((basketComp) => comparableUtils.isRelative({ maybeOriginal: comparable, maybeDerived: basketComp }));
      if (relativeComp) {
        commit('deleteToggleStatus', { id: relativeComp.id, tab });
      }

      commit('deleteToggleStatus', { id: comparable.id, tab });
    },

    updateRelativeParentsFromGlobalCollection({ getters, commit }, { tab, comparable, basketId, basketName }) {
      const globalCollectionComps = getters.getComparables(tab).filter((globalCollectionComp) => comparableUtils.isRelative({ maybeOriginal: globalCollectionComp, maybeDerived: comparable }));
      globalCollectionComps.forEach((globalCollectionComp) => {
        commit('updateComparable', {
          tab,
          comparable: {
            ...globalCollectionComp,
            BasketId: basketId,
            BasketName: basketName,
          },
        });
      });
    },

    async blockingUnselectRelatives({ dispatch, getters }, { selectedTab, comparable }) {
      const relativeComp = getters.getBasket(selectedTab).Comparables.find((basketComp) => comparableUtils.isRelative({ maybeOriginal: comparable, maybeDerived: basketComp }));
      dispatch('blockingChangeComparableStatus', { comparable: relativeComp, change: 'on', selectedTab }); // TODO this generates a race condition due to how frontend code is structured but I don't have the time to fix it
    },

    async unselectRelatives({ dispatch, getters }, { selectedTab, comparable }) {
      const relativeComp = getters.getBasket(selectedTab).Comparables.find((basketComp) => comparableUtils.isRelative({ maybeOriginal: comparable, maybeDerived: basketComp }));
      dispatch('changeComparableStatus', { comparable: relativeComp, change: 'on', selectedTab }); // TODO this generates a race condition due to how frontend code is structured but I don't have the time to fix it
    },

    async getResearchCoord({ state, getters, rootGetters, commit }, { selectedTab }) {
      const searchZoneFigureType = getters.getSearchZoneFigureType(selectedTab);
      const searchZoneFigure = getters.getSearchZoneFigure(selectedTab);
      if (searchZoneFigure) {
        let lat;
        let lng;
        if (searchZoneFigureType === 'circle') {
          lat = searchZoneFigure?.lat;
          lng = searchZoneFigure?.lng;
        }

        if (searchZoneFigureType === 'polygon') {
          const polygonCenter = mapUtils.getPolygonArrayCenter(searchZoneFigure);
          lat = polygonCenter?.lat;
          lng = polygonCenter?.lng;
        }

        return { lat, lng };
      }
    },

    async fetchComparablesBaskets({ state, getters, rootGetters, commit }, { selectedTab, isDocumentUpdate = false, comparableId }) {
      if (state.baskets.status === statusConst.LOADING) {
        return state.baskets.promise;
      }
      const deferred = new Deferred();

      commit('setBasketStatus', {
        status: statusConst.LOADING,
        promise: deferred.promise,
      });

      try {
        const params = {
          DistanceUnits: 2,
          RelationId: getters.getRelationId,
        };

        if (rootGetters.getMode === modeConst.PROPERTY) {
          const { lat, lng } = getters.getCoordinates;

          params.refLocation = {
            type: 'Point',
            coordinates: [lat, lng],
          };
        } else if (rootGetters.getMode === modeConst.RESEARCH) {
          const searchZoneFigureType = getters.getSearchZoneFigureType(selectedTab);
          const searchZoneFigure = getters.getSearchZoneFigure(selectedTab);
          if (searchZoneFigure) {
            let lat;
            let lng;
            if (searchZoneFigureType === 'circle') {
              lat = searchZoneFigure.lat;
              lng = searchZoneFigure.lng;
            }

            if (searchZoneFigureType === 'polygon') {
              const polygonCenter = mapUtils.getPolygonArrayCenter(searchZoneFigure);
              lat = polygonCenter.lat;
              lng = polygonCenter.lng;
            }

            /* MEJORA: Al cargar la página de UK, como todavía no está el mapa, no hay región pintada y por tanto no hay centro
               sin embargo ya podríamos usar la información guardada de la búsqueda
            */
            if (lat && lng) {
              params.refLocation = {
                type: 'Point',
                coordinates: [lat, lng],
              };
            }
          }
        }

        const response = await pixAxios.post('/api/Comparables/GetComparablesBaskets', params);
        const data = response?.data;

        if (isDocumentUpdate) {
          const comparableDocUpdate = data.find((basket) => basket.Comparables?.length)?.Comparables.find((comparable) => comparable.id === comparableId);
          commit('setBasketStatus', {
            status: statusConst.SUCCESS,
            promise: null,
          });
          return comparableDocUpdate;
        }

        const baskets = data.map((basket) => ({
          ...basket,
          Comparables: basket.Comparables.sort(comparableUtils.sortBasketComparables), // sort the selected comps so that when saving the order is preserved
        }));

        let selectedTab2TabCompType;

        if (rootGetters.getMode === modeConst.PROPERTY) {
          selectedTab2TabCompType = {
            [genericTabConst.SALES_COMPS]: 1,
            [genericTabConst.LEASE_COMPS]: 2,
            [genericTabConst.LAND_COMPS]: 3,
            [genericTabConst.IE_COMPS]: 4,
            [genericTabConst.RENT_SURVEY_COMPS]: 5,
          };
        }
        if (rootGetters.getMode === modeConst.RESEARCH) {
          selectedTab2TabCompType = {
            [genericTabConst.LEASE_RESEARCH]: 2,
            [genericTabConst.SALES_RESEARCH]: 1,
          };
        }

        Object.keys(selectedTab2TabCompType).forEach((basketTabName) => {
          const currentBasket = baskets.find((basket) => {
            let type;
            console.warn('Remember remove this duplicate logic for basket when script is done');

            if (basket.BasketTypeId) {
              type = basket.BasketTypeId;
            } else {
              const [default_, id, basketType] = basket.BasketName.split('_');
              type = basketType;
            }

            return Number(type) === selectedTab2TabCompType[basketTabName];
          });

          commit('setBasket', {
            value: currentBasket,
            tab: basketTabName,
          });
        });

        deferred.resolve();
        commit('setBasketStatus', {
          status: statusConst.SUCCESS,
          promise: null,
        });
      } catch (error) {
        Console.error(error);
        deferred.reject();
        commit('setBasketStatus', {
          status: statusConst.FAIL,
          promise: null,
        });
      }
    },

    setSelectedTab({ commit }, selectedTab) {
      commit('setSelectedTab', selectedTab);
    },

    setComparablesStatus({ commit }, { status, tab }) {
      commit('setComparablesStatus', { status, tab });
    },

    setSelectedComparableSet({ commit }, { set, tab }) {
      commit('setSelectedComparableSet', { set, tab });
    },

    setComparableSearchZone({ commit, dispatch }, { circle, polygon, dataLayer, selectedTab }) {
      if (circle) {
        commit('setSearchZoneFigureType', { figureType: 'circle', tab: selectedTab });
        commit('setSearchZoneFigure', { figure: circle, tab: selectedTab });
      } else if (polygon) {
        commit('setSearchZoneFigureType', { figureType: 'polygon', tab: selectedTab });
        commit('setSearchZoneFigure', { figure: polygon, tab: selectedTab });
      } else if (dataLayer) {
        commit('setSearchZoneFigureType', { figureType: 'polygon', tab: selectedTab });
        commit('setSearchZoneFigure', { figure: dataLayer, tab: selectedTab });
      }

      if (!circle && !polygon && !dataLayer) {
        dispatch('cleanComparableSearchZone', { selectedTab });
      }
    },

    cleanComparableSearchZone({ commit }, { selectedTab }) {
      commit('setSearchZoneFigureType', { figureType: null, tab: selectedTab });
      commit('setSearchZoneFigure', { figure: null, tab: selectedTab });
    },

    setProfilePage({ commit }, { selectedTab, page = 1 }) {
      commit('setProfilePage', {
        selectedTab,
        page,
      });
    },

    // TODO check for async issues
    /**
     *
     * @param {String} openModal - newLeaseCompForm: lease new comm; newCompForm: lease new multi & sales new comp; newLandCompForm: land new comp; newLeaseForm: new lease
     * @param {Number} type - 0: Comm; 1 - Multi
     * @returns
     */
    async openModalForm({ commit }, { type }) {
      commit('setModalType', type);
    },

    async openModalMlaGrids({ commit }, { type }) {
      commit('setModalMla', type);
    },

    async fetchModalForm({ state, commit }, { openModal, tab, type = null }) {
      const { status, modalForms } = state;
      // setOpenNewCompModal

      commit('setOpenModal', openModal);
      if (status.newCompForm && status.newLeaseForm) {
        return;
      }

      let newLeaseForm = modalForms.newLeaseForm;

      if (openModal === 'newLeaseForm' && !newLeaseForm) {
        commit('setStatusModal', { openModal: 'newLeaseForm', loadingState: statusConst.LOADING, isStatusTab: false, tab });
        newLeaseForm = {
          formData: await genericFormService.getGenericFormCall(formIdConst.TALOS_NEW_LEASE_COMMERCIAL_COMP),
        };
      }

      commit('setModalForms', {
        openModal,
        newLeaseForm,
      });
    },

    changeOpenModal({ state: { modalForms }, commit }, openModal) {
      commit('setOpenModal', modalForms.openModal === openModal ? '' : openModal);
    },

    closeModal({ commit }) {
      commit('setModalType', '');
    },

    closeModalMlaGrid({ commit }) {
      commit('setModalMla', null);
    },

    setNewLocation({ commit }, newLocation) {
      commit('setNewLocation', newLocation);
    },

    setModalForms({ commit }, payload) {
      commit('setModalForms', payload);
    },

    async fetchGenericComparable({ state, commit }) {
      if (state.genericComparable) {
        return state.genericComparable;
      } else {
        const { data } = await pixAxios.get('api/Comparables/GetGenericComparableMongo');
        commit('setGenericComparable', { genericComparable: data });

        return data;
      }
    },

    /**
     * Method in charge to created the comparable model, and in the diferent cases set the data that we are pass. the method also control the parent & child structure in the comp
     */
    async saveNewComparable(
      { getters, dispatch, rootGetters, commit },
      {
        newCompForm,
        newLeaseForm,
        tableFeatures = [],
        newLandForm,
        newLocation,
        langCode,
        operationType,
        operationTypeId,
        propertyTypeCode,
        propertySubTypeCode,
        countryCode,
        selectedTab,
        truncFeatures,
        transactionHistory,
        TransactionAnalysisSummaryInfo,
        amenitiesInfo,
        documents = null,
        newLeaseComparableId,
      }
    ) {
      let endpoint = 'api/Comparables/CreateComparableAndAddIntoBasket';

      const newParentAndNewChild = newCompForm?.formData?.length && newLeaseForm?.formData?.length;
      const isNewChildWithoutNewParent = !newCompForm?.formData?.length && newLeaseForm?.formData?.length;
      const priceOriginalMetric = rootGetters.currency;

      let comparable = await createComparableModel(
        { dispatch, getters },
        {
          location: newLocation,
          priceOriginalMetric,
          langCode,
          operationType,
          operationTypeId,
          propertyTypeCode,
          propertySubTypeCode,
          countryCode,
          tableFeatures,
          truncFeatures: truncFeatures?.hasOwnProperty('RentSurveyList') ? truncFeatures : amenitiesInfo,
        }
      );

      const filteredFormData = genericFormService.getFilteredByConditions(newCompForm);

      if (filteredFormData?.formData) {
        newCompForm.formData = filteredFormData.formData;
      }

      newCompForm?.formData?.forEach((field) => comparableUtils.setFieldValueInComparable(comparable, field));

      // We've had to create a deep copy of newLeaseForm because its reference was being mutated somehow, somewhere.
      const newLeaseFormCopy = _.cloneDeep(newLeaseForm);
      if (newParentAndNewChild) {
        const rootFeaturesOfChildComp = newCompForm?.formData.filter(({ InternalField }) => !InternalField.includes('ParentInfo.'));

        newLeaseFormCopy.formData = [...newLeaseFormCopy.formData, ...rootFeaturesOfChildComp];

        comparable = await createComparableModel(
          { dispatch, getters },
          {
            location: newLocation,
            priceOriginalMetric,
            langCode,
            operationType,
            operationTypeId,
            propertyTypeCode,
            countryCode,
            comparableHierLevel: 1,
            isNewParent: true,
            parentInfo: { ...comparable },
            tableFeatures,
            truncFeatures: truncFeatures?.hasOwnProperty('RentSurveyList') ? truncFeatures : amenitiesInfo,
          }
        );
        newLeaseForm = newLeaseFormCopy;
        newLeaseForm.formData?.forEach((field) => comparableUtils.setFieldValueInComparable(comparable, field));
      } else if (isNewChildWithoutNewParent) {
        const selectedComps = getters.getOrderedSelectedComparables(selectedTab);
        const parentComp = selectedComps.find((comp) => comp.id === newLeaseComparableId).ParentInfo;
        // const parentComp = getters.getSelectedComparable(selectedTab)?.ParentInfo ?? getters.getSelectedComparable(selectedTab);
        // newLeaseComparableId
        comparable.IsNewLease = true;
        comparable.IsNewParent = false;
        comparable.UpdateParent = false;
        comparable.ParentInfo = parentComp;
        comparable.Latitude = parentComp.Latitude;
        comparable.Longitude = parentComp.Longitude;
        comparable.location.coordinates = [parentComp.Longitude, parentComp.Latitude];
        comparable.ComparableHierLevel = 1;

        newLeaseForm = newLeaseFormCopy;
        newLeaseForm.formData?.forEach((field) => comparableUtils.setFieldValueInComparable(comparable, field));

        // Hardcode the default value ("false") for the verification field
        comparableUtils.setFieldValueInComparable(comparable, { InternalField: 'Verification', FieldDataType: 'bool', Value: 0 });

        endpoint = 'api/Comparables/AddLeaseToExistingParentInBasketWithSubmit';
      }

      // Add the values of the rent survey to comparable features to be able to display it correctly in the list, the popUp,...
      if (truncFeatures?.RentSurveyList?.length) {
        comparableUtils.setFieldValueInComparable(comparable, {
          InternalField: 'MFLeaseSurveyDate',
          Label: 'Date Of Survey',
          FieldDataType: 'date',
          Value: truncFeatures.RentSurveyList[0].DateOfSurvey ?? '',
        });

        const maybeUnitRowsLength = truncFeatures.RentSurveyList[0].MarketRentTable?.UnitRows?.length;
        if (maybeUnitRowsLength !== undefined && maybeUnitRowsLength !== null) {
          let avgRentUnit = marketRentUtils.getWeightedRent(truncFeatures.RentSurveyList[0].MarketRentTable.UnitRows);

          if (isNaN(parseFloat(avgRentUnit)) || !isFinite(avgRentUnit)) {
            avgRentUnit = undefined;
          }

          comparableUtils.setFieldValueInComparable(comparable, {
            InternalField: 'MFWeightedAvgRent/Unit',
            Label: 'Avg Unit Rent',
            FieldDataType: 'decimal',
            Value: avgRentUnit,
          });

          let avgRentSize = marketRentUtils.getWeightedRentPerSize(truncFeatures.RentSurveyList[0].MarketRentTable.UnitRows);

          if (isNaN(parseFloat(avgRentSize)) || !isFinite(avgRentSize)) {
            avgRentSize = undefined;
          }

          comparableUtils.setFieldValueInComparable(comparable, {
            InternalField: 'MFWeightedAvgRent/SF/Mo',
            Label: 'Avg Rent PSF',
            FieldDataType: 'decimal',
            Value: avgRentSize,
          });
        }
      }

      // Debe mirar si estamos en la pestaña de Land, y debe apuntar a newCompForm, no a newLandForm
      if (selectedTab === genericTabConst.LAND_COMPS) {
        newCompForm?.formData?.forEach((field) => comparableUtils.setFieldValueInComparable(comparable, field));
        comparable.operationType = 'Sale'; // SALE
        comparable.PropertyTypeCode = propertyUseConst.LAND;
        comparable.PropertyTypeList = [propertyUseConst.LAND];

        const propertySubTypeCode = newCompForm.formData.find(({ InternalField }) => InternalField === 'PropertySubTypeCode');
        comparable.PropertySubTypeList = propertySubTypeCode ? [propertySubTypeCode.Value] : [];
      }

      if (transactionHistory || TransactionAnalysisSummaryInfo) {
        comparable.SaleTransactionInfo = {
          TransactionHistoryInfo: [...transactionHistory],
          TransactionAnalysisSummaryInfo: { ...TransactionAnalysisSummaryInfo },
        };
      }

      comparable.AudTime = new Date();
      comparable.BasketId = getters.getBasket(selectedTab)?.id;
      if (documents) {
        comparable.Documents = documents;
      }

      if (!comparable.BasketId) {
        endpoint = 'api/Comparables/InsertGenericComparable';
        comparable = { Model: JSON.stringify(comparable) };
      }

      const { data } = await pixAxios.post(endpoint, comparable);

      if (isNewChildWithoutNewParent) {
        commit('setNewLeaseComparableID', { comparableID: data.ComparableID, selectedTab });
      }

      return data;
    },

    openPopUp({ state, commit, dispatch }, { itemId, selectedTab }) {
      let open;
      if (!state[selectedTab].infoPopUp.comparableId) {
        commit('setComparableIdPopUp', { itemId, tab: selectedTab });
        open = true;
        dispatch('setPopUpIsLoading', { loading: true, selectedTab });
      } else {
        if (state[selectedTab].infoPopUp.comparableId === itemId) {
          open = false;
          commit('setComparableIdPopUp', { itemId: null, tab: selectedTab });
        } else {
          // TODO this is mutating the state in an action

          state[selectedTab].infoPopUp.comparableId = itemId;
          open = true;
          dispatch('setPopUpIsLoading', { loading: true, selectedTab });
        }
      }

      commit('setPopUpIsOpen', { tab: selectedTab, value: open });
    },

    clearComparablePopUp({ commit }, { selectedTab }) {
      commit('clearComparablePopUp', { selectedTab });
    },

    closePopUp({ commit }, selectedTab) {
      commit('clearInfoPopUp', selectedTab);
      commit('setPopUpIsOpen', { tab: selectedTab, value: false });
    },

    getComparableById({ rootGetters }, comparableId) {
      return new Promise((resolve, reject) => {
        const params = {
          id: comparableId,
          lang: rootGetters.langCode,
        };

        pixAxios
          .post('/api/Comparables/GetComparableByID', params)
          .then((response) => {
            resolve(response);
          })
          .catch(() => {
            reject();
          });
      });
    },
    getBasketComparableById(_store, { ComparableId, BasketId }) {
      const params = {
        BasketId,
        ComparableId,
      };

      return pixAxios.post('/api/Comparables/GetBasketComparableById', params);
    },

    async getAndSetComparableToPopUp({ getters, dispatch }, { id, isDual, basketId, selectedTab }) {
      const comparableBasket = getters.getBasket(selectedTab).Comparables.find((comparable) => comparable.id === id);
      dispatch('setPopUpIsDual', { dual: isDual, selectedTab });

      if (comparableBasket) {
        const params = {
          BasketId: comparableBasket.BasketId,
          ComparableId: id,
        };
        dispatch('setComparableBasketToPopUp', { comparableBasket, selectedTab });
        dispatch('openPopUp', { itemId: id, selectedTab });
        await dispatch('getBasketComparableById', params).then((response) => {
          dispatch('addDistanteToComparable', { comparable: response.data, selectedTab });
          dispatch('setComparableToPopUp', {
            comparable: { ...response.data, BasketId: comparableBasket.BasketId },
            selectedTab,
          });
          dispatch('setPopUpIsLoading', { loading: false, selectedTab });
        });
      } else {
        dispatch('setComparableBasketToPopUp', { comparableBasket: null, selectedTab });
        dispatch('openPopUp', { itemId: id, selectedTab });
        await dispatch('getComparableById', id).then((response) => {
          dispatch('addDistanteToComparable', { comparable: response.data, selectedTab });
          dispatch('setComparableToPopUp', { comparable: { ...response.data, BasketId: basketId }, selectedTab });
          dispatch('setPopUpIsLoading', { loading: false, selectedTab });
        });
      }
    },

    setComparableToPopUp({ commit, dispatch }, { comparable, selectedTab }) {
      dispatch('addDistanteToComparable', { comparable, selectedTab });
      commit('setComparableToPopUp', { comparable, tab: selectedTab });
    },

    addDistanteToComparable({ getters }, { comparable, selectedTab }) {
      if (!comparable.DistanceToSubjectProperty) {
        const comp = getters.getFilteredComparables(selectedTab).find((comparableItem) => comparableItem.id === comparable.id);
        if (comp) {
          if (comp.ParentInfo) {
            // TODO this is mutating state in an action
            comparable.ParentInfo.DistanceToSubjectProperty = comp.DistanceToSubjectProperty;
          } else {
            // TODO this is mutating state in an action
            comparable.DistanceToSubjectProperty = comp.DistanceToSubjectProperty;
          }
        }
      } else {
        if (comparable.ParentInfo) {
          // TODO this is mutating state in an action
          comparable.ParentInfo.DistanceToSubjectProperty = comparable.DistanceToSubjectProperty;
        }
      }
    },

    goToProfileComp({ getters, dispatch }, { selectedTab, comparable, mode, set }) {
      let page = null;
      // check if comparable is in the selected basket
      const selectedComparableList = getters.getSelectedComparableSetData(selectedTab).selectedComparableSet;
      if (mode === modeConst.RESEARCH) {
        const selectedSet = getters.getOrderedSelectedComparables(selectedTab, set);

        page = selectedSet?.findIndex(({ ComparableCode, FileType }) => ComparableCode === comparable?.ComparableCode && comparable?.FileType === FileType) + 1;
      } else {
        let foundSet = null;
        const sets = [comparableSetConst.SELECTED, comparableSetConst.NO_SELECTED, comparableSetConst.ALL];
        sets.some((set) => {
          const selectedSet = getters.getFilteredComparablesSets(selectedTab)[set];
          page = selectedSet?.findIndex(({ ComparableCode, FileType }) => ComparableCode === comparable?.ComparableCode && comparable?.FileType === FileType) + 1;
          // page is 0 if not found
          if (page !== 0) {
            foundSet = set;
            return true;
          }
          return false;
        });
        if (foundSet) {
          dispatch('setSelectedComparableSet', { set: foundSet, tab: selectedTab });
          dispatch('setSelectedSubTab', { value: comparableSubTabConst.PROFILE, selectedTab });
          dispatch('setProfilePage', { selectedTab, page });
          return;
        }
      }

      if (page) {
        dispatch('setSelectedComparableSet', { set: set ?? selectedComparableList, tab: selectedTab });
      } else {
        page = getters.getOrderedSelectedComparables(selectedTab).findIndex(({ id }) => id === comparable.id) + 1;
      }

      //make routing to profile
      dispatch('setSelectedSubTab', { value: comparableSubTabConst.PROFILE, selectedTab });

      //load profile selected
      dispatch('setProfilePage', { selectedTab, page });
    },

    setComparableBasketToPopUp({ commit }, { comparableBasket, selectedTab }) {
      commit('setComparableBasketToPopUp', { comparableBasket, tab: selectedTab });
    },

    setConfiguration({ commit }, { configuration, typeInfo }) {
      commit('setConfiguration', { configuration, typeInfo });
    },

    getComparablesConfiguration({ rootGetters, getters }, typeInfo) {
      const postData = {
        Instance: rootGetters['authModule/fullInstance'],
        LangCode: rootGetters.langCode,
        TypeInfo: typeInfo,
        AppId: appIdParameter.PIX,
      };
      return pixAxios.post('/api/ComparablesConfiguration/GetCompsMapCardsConfig', postData);
    },

    getComparablesConfigurationTerraCards({ rootGetters }, { typeInfo, instance, appId }) {
      const postData = {
        Instance: instance,
        LangCode: rootGetters.langCode,
        TypeInfo: typeInfo,
        AppId: appId,
      };
      return pixAxios.post('/api/ComparablesConfiguration/GetCompsMapCardsConfig', postData);
    },

    // Action - fetch - opciones - property
    getCompListSorting() {
      return pixAxios.get('/api/MongoConfiguration/GetCompListSorting');
    },

    // Action - fetch - opciones - research busqueda
    fetchResearchCompListSorting() {
      return pixAxios.get('/api/MongoConfiguration/GetResearchCompListSorting');
    },

    // Action - fetch - opciones - research cesta
    fetchResearchBasketListSorting() {
      return pixAxios.get('/api/MongoConfiguration/GetResearchBasketListSorting');
    },

    // Action - fetch - opciones - tabla
    fetchCompTableSorting() {
      return pixAxios.get('/api/MongoConfiguration/GetCompTableSorting');
    },

    // Action - set - opciones - property
    setCompListSorting({ commit }, compListSorting) {
      commit('setCompListSorting', compListSorting);
    },

    // Action - set - opciones - tabla
    setCompTableSorting({ commit }, compTableSorting) {
      commit('setCompTableSorting', compTableSorting);
    },

    // Action - set - opciones - research busqueda
    setResearchComparablesSortingList({ commit }, researchComparablesSortingList) {
      commit('setResearchComparablesSortingList', researchComparablesSortingList);
    },

    // Action - set - opciones - research cesta
    setResearchBasketSortingList({ commit }, researchBasketSortingList) {
      commit('setResearchBasketSortingList', researchBasketSortingList);
    },

    // Action - set - campo - property
    setComparablesSortingField({ commit }, comparablesSortingField) {
      commit('setComparablesSortingField', comparablesSortingField);
    },

    // Action - set - direccion - property
    setComparablesSortingDirection({ commit }, comparablesSortingDirection) {
      commit('setComparablesSortingDirection', comparablesSortingDirection);
    },

    // Action - set - campo - research busqueda
    setResearchComparablesSortingField({ commit }, { researchComparablesSortingField, selectedTab }) {
      commit('setResearchComparablesSortingField', { researchComparablesSortingField, selectedTab });
    },

    // Action - set - direccion - research busqueda
    setResearchComparablesSortingDirection({ commit }, { researchComparablesSortingDirection, selectedTab }) {
      commit('setResearchComparablesSortingDirection', { researchComparablesSortingDirection, selectedTab });
    },

    // Action - set - paramId - research busqueda
    setResearchComparablesSortingParamId({ commit }, { researchComparablesSortingParamId, selectedTab }) {
      commit('setResearchComparablesSortingParamId', { researchComparablesSortingParamId, selectedTab });
    },

    // Action - set - campo - research cesta
    setResearchBasketSortingField({ commit }, { researchBasketSortingField, selectedTab }) {
      commit('setResearchBasketSortingField', { researchBasketSortingField, selectedTab });
    },

    // Action - set - direccion - research cesta
    setResearchBasketSortingDirection({ commit }, { researchBasketSortingDirection, selectedTab }) {
      commit('setResearchBasketSortingDirection', { researchBasketSortingDirection, selectedTab });
    },

    setSelectedMLA({ commit }, { selectedMla, tab }) {
      commit('setSelectedMLA', { selectedMla, tab });
    },

    clearInfoPopUp({ commit }, tab) {
      commit('clearInfoPopUp', tab);
    },

    setIncomeExpensesTableConfig({ commit }, incomeExpensesTableConfig) {
      commit('setIncomeExpensesTableConfig', incomeExpensesTableConfig);
    },

    addDynamicFilter({ commit }, { InternalField, selectedTab }) {
      commit('addDynamicFilter', {
        InternalField,
        selectedTab,
        newFilter: {
          value: null,
          min: null,
          max: null,
        },
      });
    },

    removeDynamicFilter({ commit }, { InternalField, index, selectedTab }) {
      commit('removeDynamicFilter', { InternalField, index, selectedTab });
    },

    initializeFilters({ commit }, { selectedTab }) {
      commit('initializeFilters', selectedTab);
    },
    setPopUpIsLoading({ commit }, { loading, selectedTab }) {
      commit('setPopUpIsLoading', { loading, selectedTab });
    },
    setPopUpIsDual({ commit }, { dual, selectedTab }) {
      commit('setPopUpIsDual', { dual, selectedTab });
    },
    setDisplayMapButtons({ commit }, { display, selectedTab }) {
      commit('setDisplayMapButtons', { display, selectedTab });
    },
    setAutomaticSearchOnShapeChange({ commit }, payload) {
      commit('setAutomaticSearchOnShapeChange', payload);
    },

    setSelectedSubTab({ commit }, payload) {
      commit('setSelectedSubTab', payload);
    },

    setProfileMla({ commit }, { profileMla, selectedTab }) {
      commit('setProfileMla', { profileMla, selectedTab });
    },

    setGoCommentSection({ commit }, value) {
      commit('setGoCommentSection', value);
    },

    setStaticColumnsConfig({ commit }, value) {
      commit('setStaticColumnsConfig', value);
    },
    clearFiltersValues({ getters, dispatch }, { selectedTab }) {
      const originalFields = _.cloneDeep(getters.getSelectedTabOriginalFilters(selectedTab));
      dispatch('initializeFilters', { originalFields, selectedTab });
    },

    setFiltersStructure({ commit }, { value, selectedTab }) {
      commit('setFiltersStructure', { value, selectedTab });
    },

    setFilters({ commit }, { value, selectedTab }) {
      commit('setFilters', { value, selectedTab });
    },
    setMapConfigIsLoaded({ commit }, { value, selectedTab }) {
      commit('setMapConfigIsLoaded', { value, selectedTab });
    },
    clearResearchLocationFilters({ state, commit }, { selectedTab }) {
      const locationFilter = state[selectedTab]?.filters?.find(({ InternalField }) => InternalField === 'Location');
      if (locationFilter) {
        commit('clearResearchLocationFilters', { locationFilter, selectedTab });
      }
    },

    async downloadDocument({ state, dispatch, rootGetters }, downloadDocumentParams) {
      dispatch('loadingOverlayModule/setIsLoading', true, { root: true });
      pixAxios
        .post('/api/Comparables/ExportCompsToExcel', downloadDocumentParams)
        .then((doc) => {
          documentUtils.exportDocument(doc, 'CompsList');
          webAnalyticsUtils.registerWebAnalyticsEvent(webAnalyticsEventsConst.SEARCH_EXPORT_COMPARABLES);
        })
        .catch((error) => {
          const detailError = JSON.parse(error?.response?.data?.detail);
          const detailErrorMessage = JSON.parse(detailError.detail);
          dispatch('toastModule/error', detailErrorMessage.message, { root: true });
        })
        .finally(() => {
          dispatch('loadingOverlayModule/setIsLoading', false, { root: true });
        });
    },
  },

  mutations: {
    resetState(state) {
      Object.assign(state, createInitialState());
    },
    toggleFilterStudioActive(state, payload) {
      state[genericTabConst.LEASE_COMPS].filters.Studio = payload;
    },
    toggleFilterBR1Active(state, payload) {
      state[genericTabConst.LEASE_COMPS].filters.BR1 = payload;
    },
    toggleFilterBR2Active(state, payload) {
      state[genericTabConst.LEASE_COMPS].filters.BR2 = payload;
    },
    toggleFilterBR3Active(state, payload) {
      state[genericTabConst.LEASE_COMPS].filters.BR3 = payload;
    },
    toggleFilterBR4PlusActive(state, payload) {
      state[genericTabConst.LEASE_COMPS].filters.BR4Plus = payload;
    },
    setSavedComparableProfile(state, comparable) {
      state.savedComparableProfile = comparable;
    },
    setFilterValue(state, { filter, value, property }) {
      Vue.set(filter, property, value);
    },
    setLastSelectedTwelveMonthFlagFilter(state, { selectedTab, value }) {
      Vue.set(state[selectedTab], 'TwelveMonth', value);
    },

    setGenericComparable(state, { genericComparable }) {
      state.genericComparable = genericComparable;
    },

    setComparablesStatus(state, { status, tab }) {
      state[tab].status.comparables = status;
    },

    setSelectedTab(state, selectedTab) {
      state.selectedTab = selectedTab;
    },

    setSelectedComparableSet(state, { set, tab }) {
      state[tab].selectedComparableSet = set;
    },

    setProfilePage(state, { selectedTab, page }) {
      state[selectedTab].profilePage = page;
    },

    setOpenModal(state, openModal) {
      state.modalForms.openModal = openModal;
    },

    setStatusModal(state, { key, loadingState, isStatusTab = true, tab }) {
      if (isStatusTab) {
        state[tab].status[key] = loadingState;
      } else {
        state.status[key] = loadingState;
      }
    },

    setModalForms(state, modalForm) {
      state.status.newCompForm = modalForm.newCompForm && statusConst.SUCCESS;
      state.status.newLeaseForm = modalForm.newLeaseForm && statusConst.SUCCESS;
      state.status.newLandForm = modalForm.newLandForm && statusConst.SUCCESS;
      state.modalForms = modalForm;
      state.newLocation = modalForm.newLocation;
    },

    setComparables(state, { tab, comparables }) {
      state[tab].comparables = comparables;
    },

    setComparablesWithoutSummation(state, { tab, comparablesFromCallWithoutSummation }) {
      state[tab].comparablesFromCallWithoutSummation = comparablesFromCallWithoutSummation;
    },

    setComparablesBasket(state, { tab, comparables }) {
      Vue.set(state[tab].basket, 'Comparables', comparables);
    },

    updateBasketComparable(state, { tab, comparable }) {
      state[tab].basket.Comparables = state[tab].basket.Comparables.map((comp) => {
        if (comp.id === comparable.id) {
          return comparable;
        } else {
          return comp;
        }
      });
    },

    updateComparable(state, { tab, comparable }) {
      state[tab].comparables = state[tab].comparables.map((comp) => {
        if (comparable.id === comp.id) {
          return {
            ...comparable,
          };
        } else {
          return comp;
        }
      });
    },

    setModalType(state, type) {
      state.modalType = type;
    },

    setModalMla(state, type) {
      state.modalMlaGrid = type;
    },

    setNewLocation(state, newLocation) {
      state.modalForms.newLocation = newLocation;
    },

    setOpenPopUp(state, { value, tab }) {
      state[tab].infoPopUp.isOpen = value;
    },

    setComparableIdPopUp(state, { itemId, tab }) {
      state[tab].infoPopUp.comparableId = itemId;
    },
    setPopUpIsOpen(state, { tab, value }) {
      state[tab].infoPopUp.isOpen = value;
    },
    setComparableToPopUp(state, { comparable, tab }) {
      state[tab].infoPopUp.comparable = comparable;
    },
    setComparableBasketToPopUp(state, { comparableBasket, tab }) {
      state[tab].infoPopUp.comparableBasket = comparableBasket;
    },
    setConfiguration(state, { configuration, typeInfo }) {
      Vue.set(state.configuration, typeInfo, configuration);
    },

    // Mutation - set - opciones - property
    setCompListSorting(state, compListSorting) {
      state.compListSorting = compListSorting;
    },

    // Mutation - set - opciones - tabla
    setCompTableSorting(state, compTableSorting) {
      state.compTableSorting = { ...compTableSorting };
    },

    // Mutation - set - opciones - research busqueda
    setResearchComparablesSortingList(state, researchComparablesSortingList) {
      state.researchComparablesSortingList = researchComparablesSortingList;
    },

    // Mutation - set - opciones - research cesta
    setResearchBasketSortingList(state, researchBasketSortingList) {
      state.researchBasketSortingList = researchBasketSortingList;
    },

    // Mutation - set - campo - property
    setComparablesSortingField(state, comparablesSortingField) {
      if (!comparablesSortingField) {
        state.comparablesSortingField = null;
      } else {
        state.comparablesSortingField = { ...comparablesSortingField };
      }
    },

    // Mutation - set - direccion - property
    setComparablesSortingDirection(state, comparablesSortingDirection) {
      state.comparablesSortingDirection = comparablesSortingDirection;
    },

    // Mutation - set - campo - research busqueda
    setResearchComparablesSortingField(state, { researchComparablesSortingField, selectedTab }) {
      if (!researchComparablesSortingField) {
        state[selectedTab].researchComparableSortField = null;
      } else {
        state[selectedTab].researchComparableSortField = researchComparablesSortingField;
      }
    },

    // Mutation - set - direccion - research busqueda
    setResearchComparablesSortingDirection(state, { researchComparablesSortingDirection, selectedTab }) {
      state[selectedTab].researchComparableSortDirection = researchComparablesSortingDirection;
    },

    // Mutation - set - direccion - research busqueda
    setResearchComparablesSortingParamId(state, { researchComparablesSortingParamId, selectedTab }) {
      state[selectedTab].researchComparablesSortParamId = researchComparablesSortingParamId;
    },

    // Mutation - set - campo - research cesta
    setResearchBasketSortingField(state, { researchBasketSortingField, selectedTab }) {
      if (!researchBasketSortingField) {
        state[selectedTab].researchBasketSortField = null;
      } else {
        state[selectedTab].researchBasketSortField = researchBasketSortingField;
      }
    },

    // Mutation - set - direccion - research cesta
    setResearchBasketSortingDirection(state, { researchBasketSortingDirection, selectedTab }) {
      state[selectedTab].researchBasketSortDirection = researchBasketSortingDirection;
    },

    setSearchZoneFigureType(state, { figureType, tab }) {
      state[tab].zone.figureType = figureType;
    },

    setSearchZoneFigure(state, { figure, tab }) {
      state[tab].zone.figure = figure;
    },

    setBasket(state, { value, tab }) {
      state[tab].basket = value;
    },

    setSelectedMLA(state, { selectedMla, tab }) {
      state[tab].selectedMLA = selectedMla;
    },

    setToggleStatus(state, { id, change, tab }) {
      const item = state[tab].status.toggleStatusList.find(({ id: itemId }) => itemId === id);

      if (item) {
        item.change = change;
      } else {
        const statusToPush = {
          id,
          isLoading: true,
          buttonClicked: change,
        };
        state[tab].status.toggleStatusList.push(statusToPush);
      }
    },

    deleteToggleStatus(state, { id, tab }) {
      state[tab].status.toggleStatusList = state[tab].status.toggleStatusList.filter((item) => item.id !== id);
    },

    clearPagination(state, tab) {
      state[tab].showMore = 0;
    },

    clearInfoPopUp(state, tab) {
      state[tab].infoPopUp = {
        comparable: null,
        comparableId: null,
        isLoading: null,
        isLoaded: null,
        isOpen: null,
        comparableBasket: null,
      };
    },
    clearComparablePopUp(state, { selectedTab }) {
      state[selectedTab].infoPopUp.comparable = null;
    },

    setIncomeExpensesTableConfig(state, incomeExpensesTableConfig) {
      state[genericTabConst.IE_COMPS].tableConfig = incomeExpensesTableConfig;
    },

    addDynamicFilter(state, { InternalField, selectedTab, newFilter }) {
      const filter = state[selectedTab].filters.find(({ InternalField: filterInternalField }) => filterInternalField === InternalField);

      filter && filter.DynamicFiltersList.push(newFilter);
    },

    removeDynamicFilter(state, { InternalField, index, selectedTab }) {
      const filter = state[selectedTab].filters.find(({ InternalField: filterInternalField }) => filterInternalField === InternalField);

      if (filter && filter.DynamicFiltersList.length > 1) {
        filter.DynamicFiltersList.splice(index, 1);
      }
    },

    initializeFilters(state, tab) {
      Vue.set(state[tab], 'filters', _.cloneDeep(state[tab].originalFilters));
    },

    setPopUpIsLoading(state, { loading, selectedTab }) {
      Vue.set(state[selectedTab].infoPopUp, 'isLoading', loading);
    },
    setPopUpIsDual(state, { dual, selectedTab }) {
      Vue.set(state[selectedTab].infoPopUp, 'isDual', dual);
    },
    setDisplayMapButtons(state, { display, selectedTab }) {
      Vue.set(state[selectedTab], 'displayMapButtons', display);
    },
    setAutomaticSearchOnShapeChange(state, { value, selectedTab }) {
      Vue.set(state[selectedTab], 'automaticSearchOnShapeChange', value);
    },
    setSelectedSubTab(state, { value, selectedTab }) {
      Vue.set(state[selectedTab], 'selectedSubTab', value);
    },
    setProfileMla(state, { profileMla, selectedTab }) {
      Vue.set(state[selectedTab], 'profileMla', profileMla);
    },
    setGoCommentSection(state, { value, selectedTab }) {
      Vue.set(state[selectedTab], 'goToCommentSection', value);
    },
    setStaticColumnsConfig(state, { value, selectedTab }) {
      Vue.set(state[selectedTab], 'staticColumnsConfig', value);
    },

    setBasketStatus(state, { status, promise }) {
      Vue.set(state.baskets, 'status', status);
      Vue.set(state.baskets, 'promise', promise);
    },

    setFiltersStructure(state, { value, selectedTab }) {
      Vue.set(state[selectedTab], 'filtersStructure', value);
    },
    setFilters(state, { value, selectedTab }) {
      Vue.set(state[selectedTab], 'filters', value);
    },
    setMapConfigIsLoaded(state, { value, selectedTab }) {
      Vue.set(state[selectedTab], 'mapConfigIsLoaded', value);
    },
    clearResearchLocationFilters(state, { selectedTab }) {
      const locationFilter = state[selectedTab].filters.find((el) => el.InternalField === 'Location');
      if (locationFilter) {
        Vue.set(locationFilter, 'Area', null);
        Vue.set(locationFilter, 'SearchType', null);
        Vue.set(locationFilter, 'Location', null);
        Vue.set(locationFilter, 'FreeText', null);
        Vue.set(locationFilter, 'Polygon', null);
      }
    },
    setNewLeaseComparableID(state, { comparableID, selectedTab }) {
      Vue.set(state[selectedTab], 'newLeaseComparableID', comparableID);
    },
  },

  getters: {
    getOrderedSelectedComparables: (state, getters, rootGetters) => {
      return (tab, set) => {
        const frontendSortingCriteria = getters.getFrontendSortingCriteria(tab);
        const sortingFunction = comparableSortingUtils.sortingFunctionGenerator(frontendSortingCriteria, rootGetters);

        const hasFrontendSorting = frontendSortingCriteria?.sortDir && frontendSortingCriteria?.sortFld;
        const selectedComparableSet = getters.getSelectedComparableSet(tab);
        const sortedInBacked = (set ?? selectedComparableSet) === comparableSetConst.ALL;

        if ((rootGetters.mode !== modeConst.PROPERTY && sortedInBacked) || !hasFrontendSorting) {
          if (set) {
            return getters.getFilteredComparablesSets(tab)[set];
          } else {
            return getters.getFilteredComparables(tab);
          }
        }

        let sortedComps = getters.getFilteredComparables(tab);
        if (set) {
          sortedComps = getters.getFilteredComparablesSets(tab)[set];
        }

        if (frontendSortingCriteria.sortFld === 'TransactionType') {
          sortedComps = getters.sortListInBasketByTransactionStatusParamDesc(sortedComps, frontendSortingCriteria);
        } else {
          sortedComps = [...sortedComps].sort(sortingFunction);
        }

        if (frontendSortingCriteria.sortDir.toUpperCase() === 'DESC' || frontendSortingCriteria.sortDir.toUpperCase() === 'DES') {
          sortedComps.reverse();
        }

        return sortedComps;
      };
    },

    getSelectedTabUse: (state) => (tab) => {
      return state[tab].filters?.find((filter) => filter.InternalField === 'PropertyTypeList')?.Value ?? null;
    },

    getAllComparables: (state, getters) => (tab) => {
      return getters.getFilteredComparablesSets(tab)[comparableSetConst.ALL];
    },

    getFilteredComparablesSets: (state, getters, rootState, rootGetters) => (tab) => {
      let comparables = [...getters.getComparables(tab)];
      let basketComps = [];
      if (comparables && state[tab].basket && state[tab].basket.Comparables) {
        /** Loop over selected tab, with basket find (index of duplicated basket)*/
        state[tab].basket.Comparables.forEach((comparable) => {
          basketComps.push(comparable);
          // Research no longer uses merge
          if (rootGetters.getMode !== modeConst.RESEARCH) {
            const foundComparableIndexes = comparableUtils.findDuplicatedComparablesFrom(comparables, comparable);
            if (foundComparableIndexes.length === 0) {
              comparables.push(comparable);
            } else {
              const [index, ...rest] = foundComparableIndexes;
              // Comparable from query (that matches a comparable from basket)
              comparables[index] = comparable;
              rest.forEach((index) => {
                comparables.splice(index, 1);
              });
            }
          }
        });
      } else if (state[tab].basket && state[tab].basket.Comparables) {
        comparables = state[tab].basket.Comparables;
      }

      if (!comparables) {
        comparables = [];
      }

      if (rootGetters.getMode === modeConst.RESEARCH) {
        const frontendSortingCriteria = getters.getFrontendSortingCriteria(tab);
        if (frontendSortingCriteria?.sortDir && frontendSortingCriteria?.sortFld) {
          const sortingFunction = comparableSortingUtils.sortingFunctionGenerator(frontendSortingCriteria, rootGetters);
          basketComps = basketComps.sort(sortingFunction);
        }
      }

      return {
        [comparableSetConst.ALL]: comparables,
        [comparableSetConst.SELECTED]: basketComps?.filter((comp) => comp.ComparableStatus === 'on'),
        [comparableSetConst.NO_SELECTED]: basketComps?.filter((comp) => comp.ComparableStatus === 'off'),
      };
    },

    getFilteredComparables: (state, getters) => (tab) => {
      return getters.getFilteredComparablesSets(tab)[state[tab].selectedComparableSet];
    },

    getSelectedComparableSetData:
      (state, getters) =>
        (type, selectedMla = null) => {
          if (state[type]) {
            const { selectedComparableSet, profilePage: page } = state[type];

            // TODO Refactorizar el length de los comparables, calcular solo una vez en el set??¿
            let filteredComparablesList = getters.getFilteredComparablesSets(type);

            if (selectedMla) {
              const comparableList = getters.getFilteredMlaComparables(selectedMla, type);
              filteredComparablesList = {
                [comparableSetConst.ALL]: comparableList,
                [comparableSetConst.SELECTED]: comparableList.filter((comp) => comp.ComparableStatus === 'on'),
                [comparableSetConst.NO_SELECTED]: comparableList.filter((comp) => comp.ComparableStatus === 'off'),
              };
            }

            return {
              comparable: filteredComparablesList[selectedComparableSet][page - 1],
              selectedComparableSet,
              [comparableSetConst.ALL]: filteredComparablesList[comparableSetConst.ALL].length,
              [comparableSetConst.SELECTED]: filteredComparablesList[comparableSetConst.SELECTED].length,
              [comparableSetConst.NO_SELECTED]: filteredComparablesList[comparableSetConst.NO_SELECTED].length,
              page,
              totalCounts: state[type].showMore,
            };
          }
        },

    getSelectedComparable: (state, getters) => (tab) => {
      if (tab) {
        const profileMla = state[tab]?.profileMla;
        return getters.getSelectedComparableSetData(tab, profileMla)?.comparable;
      } else {
        return null;
      }
    },

    getSelectedComparableSet: (state) => (tab) => {
      return state[tab].selectedComparableSet;
    },

    getSelectedComparablesByTab(state, getters) {
      return (tab) => {
        return getters.getFilteredComparablesSets(tab)[comparableSetConst.SELECTED];
      };
    },

    getModalForms(state) {
      return state.modalForms;
    },

    getModalType(state) {
      return state.modalType;
    },

    getModalMlaGrid(state) {
      return state.modalMlaGrid;
    },

    getNewLocation(state) {
      return state.modalForms.newLocation;
    },

    getSelectedTabFilters: (state) => (tab) => {
      return state[tab].filters;
    },
    getSelectedTabOriginalFilters: (state) => (tab) => {
      return state[tab].originalFilters;
    },

    getComparablesStatus: (state) => (tab) => {
      return state[tab].status.comparables;
    },
    getComparablesToList: (state, getters, rootState, rootGetters) => (tab) => {
      // TODO remove propertyModule
      const property = rootState.propertyModule.property;

      if (property?.attributes) {
        const propertyTypeValue = property.attributes.find((a) => a.FeatureName === 'SubjectInfoPropertyType');
        const propertyNameValue = property.attributes.find((a) => a.FeatureName === 'SubjectInfoPropertyName');

        if (propertyTypeValue) {
          property.PropertyTypeCode = propertyTypeValue.StringValue;
          property.PropertyName = propertyNameValue.StringValue;
        }
      }

      const listComparables = property ? [property, ...getters.getOrderedSelectedComparables(tab)] : [...getters.getOrderedSelectedComparables(tab)];

      const configuration = [];

      if (genericTabsUtils.isLeaseTab(tab) && state.configuration[typeInfoConfiguration.LeaseList] && state.configuration[typeInfoConfiguration.ComercialLeaseList]) {
        configuration.push({
          condition: (comp) => !comp.ParentInfo,
          typeInfo: typeInfoConfiguration.LeaseList,
          config: [...state.configuration[typeInfoConfiguration.LeaseList]],
        });
        configuration.push({
          condition: (comp) => comp.ParentInfo,
          typeInfo: typeInfoConfiguration.ComercialLeaseList,
          config: [...state.configuration[typeInfoConfiguration.ComercialLeaseList]],
        });
      }
      if (genericTabsUtils.isRentSurveyTab(tab) && state.configuration[typeInfoConfiguration.LeaseList] && state.configuration[typeInfoConfiguration.ComercialLeaseList]) {
        configuration.push({
          condition: (comp) => !comp.ParentInfo,
          typeInfo: typeInfoConfiguration.LeaseList,
          config: [...state.configuration[typeInfoConfiguration.LeaseList]],
        });
        configuration.push({
          condition: (comp) => comp.ParentInfo,
          typeInfo: typeInfoConfiguration.ComercialLeaseList,
          config: [...state.configuration[typeInfoConfiguration.ComercialLeaseList]],
        });
      }
      if (genericTabsUtils.isSalesTab(tab) && state.configuration[typeInfoConfiguration.SalesList]) {
        configuration.push({
          condition: () => true,
          typeInfo: typeInfoConfiguration.SalesList,
          config: [...state.configuration[typeInfoConfiguration.SalesList]],
        });
      }
      if (genericTabsUtils.isLandTab(tab) && state.configuration[typeInfoConfiguration.LandList]) {
        configuration.push({
          condition: () => true,
          typeInfo: typeInfoConfiguration.LandList,
          config: [...state.configuration[typeInfoConfiguration.LandList]],
        });
      }
      if (tab === genericTabConst.IE_COMPS && state.configuration[typeInfoConfiguration.IEList]) {
        configuration.push({
          condition: () => true,
          typeInfo: typeInfoConfiguration.IEList,
          config: [...state.configuration[typeInfoConfiguration.IEList]],
        });
      }

      if (configuration.length) {
        //   const frontendSortingCriteria = getters.getFrontendSortingCriteria(tab);
        //   if (!frontendSortingCriteria?.sortDir || !frontendSortingCriteria?.sortFld) {
        //     listComparables = property ? [property, ...listComparables] : [...listComparables];
        //     return listItemUtils.getComparablesList(listComparables, configuration, rootGetters);
        //   }

        //   const sortingFunction = comparableSortingUtils.sortingFunctionGenerator(frontendSortingCriteria, rootGetters);

        //   let sortedComps = [...listComparables];

        //   const selectedComparableSet = getters.getSelectedComparableSet(tab);

        //   if (selectedComparableSet === comparableSetConst.SELECTED || rootGetters.getMode === modeConst.PROPERTY) {
        //     /**
        //      * Se ha puesto esta condicion para solucionar un error de Ordenacion pedido en el
        //      * el siguiente ticket: https://dev.azure.com/JLL-Applications/GLOBAL-PIX/_workitems/edit/1616600
        //      *
        //      * El este fix solo contempla la correccion descrita en el bug. "solo se orderna por el paramList transaction status"
        //      */
        //     if (frontendSortingCriteria.sortFld === 'TransactionType') {
        //       sortedComps = getters.sortListInBasketByTransactionStatusParamDesc(sortedComps, frontendSortingCriteria);
        //     } else {
        //       sortedComps = [...sortedComps].sort(sortingFunction);
        //     }
        //   }

        //   if (frontendSortingCriteria.sortDir === 'ASC' || frontendSortingCriteria.sortDir === 'asc') {
        //     if (property) {
        //       sortedComps.unshift(property);
        //     }
        //     return listItemUtils.getComparablesList(sortedComps, configuration, rootGetters);
        //   } else {
        //     if (rootGetters.getMode === modeConst.PROPERTY || selectedComparableSet === comparableSetConst.SELECTED) {
        //       sortedComps.reverse();
        //     }
        //     if (property) {
        //       sortedComps.unshift(property);
        //     }
        //     return listItemUtils.getComparablesList(sortedComps, configuration, rootGetters);
        //   }
        // }
        return listItemUtils.getComparablesList(listComparables, configuration, rootGetters);
      }
      return null;
    },

    sortListInBasketByTransactionStatusParamDesc(store, getters, rootState, rootGetters) {
      return (listCompsInBasket, frontendSortingCriteria) => {
        const paramList = rootState.paramListModule.paramLists.find(({ paramCode }) => paramCode === 'TransactionStatus');

        return comparableOrderingUtils.orderComparablesByParamList(listCompsInBasket, frontendSortingCriteria.sortFld, paramList?.paramListEnum, comparableOrderingUtils.ParamListFields.ValueDesc);
      };
    },

    getGenericComparable(state) {
      return state.genericComparable;
    },

    getFilteredMlaComparables: (state, getters, rootState) => (selectedMla, tab) => {
      return getters.getFilteredComparables(tab).filter((comparable) => {
        const mlaValue = comparableUtils.getFieldValueFromComp(comparable, 'ComparableMLA', rootState.langCode.toUpperCase());
        return mlaValue?.split(';').some((mlaEl) => mlaEl.toLowerCase() === selectedMla.toLowerCase());
      });
    },

    getSelectedOperation: () => (selectedTab) => {
      const selectedOperations = {
        [genericTabConst.SALES_COMPS]: '01',
        [genericTabConst.LEASE_COMPS]: '02',
        [genericTabConst.LAND_COMPS]: '01',
        [genericTabConst.IE_COMPS]: '03',
        [genericTabConst.SALES_RESEARCH]: '01',
        [genericTabConst.LEASE_RESEARCH]: '02',
        [genericTabConst.LAND_RESEARCH]: '01',
        [genericTabConst.RENT_SURVEY_COMPS]: '02',
      };

      return selectedOperations[selectedTab];
    },

    getRelationId(state, getters, rootState, rootGetters) {
      let relationId;
      if (rootGetters.getMode === modeConst.PROPERTY) {
        relationId = rootState.propertyModule.property?.RowId;
      }

      if (rootGetters.getMode === modeConst.RESEARCH) {
        relationId = rootState.researchModule.selectedSearch?.id;
      }
      return relationId;
    },

    getCoordinates(state, getters, rootState, rootGetters) {
      let lat, lng;

      if (rootGetters.getMode === modeConst.PROPERTY) {
        const property = rootState.propertyModule.property;
        if (!property) {
          Console.warn('Unable to load the property properly');
        }
        lat = property?.attributes?.find((attribute) => attribute.FeatureName === 'SubjectInfoLatitude').DecimalValue ?? 0;
        lng = property?.attributes?.find((attribute) => attribute.FeatureName === 'SubjectInfoLongitude').DecimalValue ?? 0;
      }

      if (rootGetters.getMode === modeConst.RESEARCH) {
        //obtener cordenadas de la búsqueda (researchModule)
        lat = 0;
        lng = 0;
      }

      return { lat, lng };
    },

    getTwelveMonthFlagFilter(state, getters, rootState, rootGetters) {
      return (selectedTab) => {
        return state[selectedTab].filtersStructure?.Filters[0]?.Filters.find((e) => e.Field.MetricKey === 'IncomeExpenses.CustomFilterIsOnly12MonthIncomeExpense')?.Values[0] !== '02';
      };
    },

    getLastSelectedTwelveMonthFlagFilter(state, getters, rootState, rootGetters) {
      return (selectedTab) => {
        return state[selectedTab].TwelveMonth;
      };
    },

    getComparablesFilter(state, getters, rootState, rootGetters, requestId = 1) {
      const mapCoordinates = (coords) => {
        const mappedCoordinates = coords.map((b) => [b.lng, b.lat]);
        return [...mappedCoordinates, mappedCoordinates[0]]; // set the last point equal to the first (GeoJson) so that the polygon is closed
      };
      return (selectedTab) => {
        const isFreeText = state[selectedTab].filters.find(({ InternalField }) => InternalField === 'Location')?.SearchType?.ValueCode === locationFilterConst.FREE_TEXT;

        let circle;
        let polygon;

        const searchZoneFigureType = getters.getSearchZoneFigureType(selectedTab);
        const searchZoneFigure = getters.getSearchZoneFigure(selectedTab);

        if (!isFreeText) {
          if (searchZoneFigureType === 'circle' && _.isObject(searchZoneFigure) && !_.isEmpty(searchZoneFigure)) {
            circle = {
              isCircle: true,
              ...searchZoneFigure,
            };
          } else if (searchZoneFigureType === 'polygon') {
            let coordinates;
            if (searchZoneFigure?.length) {
              // if multipolygon (RESEARCH MODE), set to array of each polygon coordinates
              coordinates = searchZoneFigure.map((a) => {
                return mapCoordinates(a.coordinates);
              });
            } else {
              // if simple polygon (PROPERTY MODE), set to array of the polygon coordinates
              coordinates = [mapCoordinates(searchZoneFigure.coordinates)];
            }

            polygon = {
              isPolygon: true,
              type: 'POLYGON',
              id: searchZoneFigure.id,
              // backend asks for a list of lists of coordinate pairs ([ [ [0,0], [1,1], [0,0] ] ])
              coordinates,
            };
          }
        }

        let ret = {};
        const comparableSortList = getters.getComparableSortList(selectedTab);
        const defaultSortList = state[selectedTab].sortList; // previous or default sorting
        const sortList = comparableSortList || defaultSortList;

        try {
          ret = {
            filter: state[selectedTab].filtersStructure,
            sortFld: null,
            sortDir: null,
            sortList,
            circle,
            polygon,
            requestId,
            lang: rootState.langCode,
            relationId: getters.getRelationId,
            SearchText: state[selectedTab].filters.find(({ InternalField }) => InternalField === 'Location')?.FreeText || undefined,
            DistanceUnits: getters.getInstanceToUnits,
          };

          if (rootGetters.getMode === modeConst.PROPERTY) {
            const { lat, lng } = getters.getCoordinates;

            ret.sortList.push({ sortFld: 'DistanceToSubject', sortDir: 'asc', paramId: 0, instanceRol: rootGetters['authModule/fullInstance'] });
            ret.refLocation = {
              type: 'Point',
              coordinates: [lat, lng],
            };
          }

          if (rootGetters.getMode === modeConst.RESEARCH) {
            // Takes the center of the shape, Free text searchs doesn't have a center
            if (searchZoneFigure && !isFreeText) {
              let lat;
              let lng;
              if (searchZoneFigureType === 'circle') {
                lat = searchZoneFigure.lat;
                lng = searchZoneFigure.lng;
              }

              if (searchZoneFigureType === 'polygon') {
                const polygonCenter = mapUtils.getPolygonArrayCenter(searchZoneFigure);
                lat = polygonCenter.lat;
                lng = polygonCenter.lng;
              }

              ret.refLocation = {
                type: 'Point',
                coordinates: [lat, lng],
              };
            }
          }
        } catch (err) {
          Console.error(err);
        }

        return ret;
      };
    },

    getComparableToPopUp: (state, getters, rootState, rootGetters) => (selectedTab) => {
      //comprobar en el state el Id del comparable que tenemos que pedir
      if (state[selectedTab].infoPopUp.comparable) {
        const configuration = {};
        let isDual = Boolean(state[selectedTab].infoPopUp.comparable.ParentInfo);

        if (genericTabsUtils.isLeaseTab(selectedTab) && isDual) {
          configuration.childConfiguration = state.configuration[typeInfoConfiguration.ComercialLeasePopupChild];
          configuration.parentConfiguration = state.configuration[typeInfoConfiguration.ComercialLeasePopupParent];
        }
        if (genericTabsUtils.isLeaseTab(selectedTab) && !isDual) {
          configuration.childConfiguration = state.configuration[typeInfoConfiguration.LeasePopup];
        }
        if (genericTabsUtils.isRentSurveyTab(selectedTab) && isDual) {
          configuration.childConfiguration = state.configuration[typeInfoConfiguration.ComercialLeasePopupChild];
          configuration.parentConfiguration = state.configuration[typeInfoConfiguration.ComercialLeasePopupParent];
        }
        if (genericTabsUtils.isRentSurveyTab(selectedTab) && !isDual) {
          configuration.childConfiguration = state.configuration[typeInfoConfiguration.LeasePopup];
        }
        if (genericTabsUtils.isSalesTab(selectedTab)) {
          configuration.childConfiguration = state.configuration[typeInfoConfiguration.SalesPopUp];
          isDual = false;
        }
        if (genericTabsUtils.isLandTab(selectedTab)) {
          configuration.childConfiguration = state.configuration[typeInfoConfiguration.LandPopup];
          isDual = false;
        }
        if (genericTabsUtils.isIETab(selectedTab)) {
          configuration.childConfiguration = state.configuration[typeInfoConfiguration.IEPopup];
          isDual = false;
        }

        const infoPopUpToShow = popUpUtils.getComparableToPopUp(state[selectedTab].infoPopUp.comparable, configuration, isDual, rootGetters);

        infoPopUpToShow.comparableBasket = state[selectedTab].infoPopUp.comparableBasket;
        return infoPopUpToShow;
      }
    },

    getComparablesToPagination(state, getters, rootState, rootGetters) {
      return (selectedTab, parentComparableId, childComparableId, selectedComparableSet) => {
        // save them in a map as there could be duplicates in research which we don't wanna count twice
        const comparablesToPagination = new Map();

        const checkAndAddToPagination = (comparable) => {
          if (comparable?.ParentInfo?.id === parentComparableId && !comparablesToPagination.get(comparable.ComparableCode)) {
            comparablesToPagination.set(comparable.ComparableCode, {
              id: comparable.id,
              basketId: comparable.BasketId,
              selected: childComparableId === comparable.id,
            });
          }
        };

        // if mode is research we have to search on the selected comparable set and not on all because a merge of comps is not made in the all collection
        if (rootGetters.getMode === modeConst.RESEARCH) {
          getters.getFilteredComparablesSets(selectedTab)[selectedComparableSet]?.forEach(checkAndAddToPagination);
        } else {
          getters.getFilteredComparablesSets(selectedTab)[comparableSetConst.ALL]?.forEach(checkAndAddToPagination);
        }
        return [...comparablesToPagination.values()];
      };
    },

    getInfoPopUp: (state) => (tab) => {
      return state[tab].infoPopUp;
    },

    // Getter - opciones - property
    getCompListSorting(state) {
      return state.compListSorting;
    },

    // Getter - opciones - tabla
    getCompTableSorting(state) {
      return state.compTableSorting;
    },

    // Getter - opciones - research busqueda
    getResearchComparablesSortingList(state) {
      return state.researchComparablesSortingList;
    },

    // Getter - opciones - research cesta
    getResearchBasketSortingList(state) {
      return state.researchBasketSortingList;
    },

    // Getter - direccion - property
    getComparablesSortingDirection(state) {
      return state.comparablesSortingDirection;
    },

    // Getter - campo - property
    getComparablesSortingField(state) {
      return state.comparablesSortingField;
    },

    getComparables: (state) => (selectedTab) => {
      return state[selectedTab]?.comparables || [];
    },

    getComparablesWithoutSummation: (state) => (selectedTab) => {
      return state[selectedTab ?? state.selectedTab]?.comparablesFromCallWithoutSummation || [];
    },

    // Getter - opciones - property - filtrado
    getCompListSortingOptions(state, getters, rootState, rootGetters) {
      return (tab) => {
        const propertyCode = getters.getSelectedTabUse(tab)?.ValueCode;
        const comparableType = pixUtils.getSortableFieldTabKey(tab);
        if (state.compListSorting && propertyCode && comparableType) {
          let propertyType;
          if (propertyUtils.isMultifamilyType(propertyCode)) {
            propertyType = 'RESIDENTIAL_TYPES';
          } else if (propertyUtils.isCommercialType(propertyCode)) {
            propertyType = 'COMMERCIAL_TYPES';
          }

          const sortingOptionsFromMongo = state.compListSorting?.CONFIG_PARAMS?.[rootGetters['authModule/fullInstance']]?.[comparableType]?.[propertyType];
          if (!sortingOptionsFromMongo) {
            Console.error('Error in compListSortingOptions');
            Console.error({
              instance: rootGetters['authModule/fullInstance'],
              comparableType,
              propertyType,
              compListSorting: state.compListSorting,
            });
          }
          return sortingOptionsFromMongo || [];
        }
      };
    },

    // Getter - opciones - research busqueda - filtrado
    getResearchCompListSortingOptions(state, getters, rootState, rootGetters) {
      return (tab) => {
        if (state.researchComparablesSortingList) {
          const comparableType = pixUtils.getSortableFieldTabKey(tab);
          return state.researchComparablesSortingList?.CONFIG_PARAMS[rootGetters['authModule/fullInstance']][comparableType] || [];
        }
      };
    },

    // Getter - opciones - research cesta - filtrado
    getResearchBasketListSortingOptions(state, getters, rootState, rootGetters) {
      return (selectedTab) => {
        if (state.researchBasketSortingList) {
          const comparableType = pixUtils.getSortableFieldTabKey(selectedTab);
          return state.researchBasketSortingList?.CONFIG_PARAMS[rootGetters['authModule/fullInstance']][comparableType] || [];
        }
      };
    },

    // Getter - opciones - tabla - filtrado
    getCompTableSortingOptions(state, getters, rootState, rootGetters) {
      return (selectedTab) => {
        if (state.compTableSorting) {
          const propertyCode = getters.getSelectedTabUse(selectedTab)?.ValueCode;
          const comparableType = pixUtils.getSortableFieldTabKey(selectedTab);
          const sortingOptions = state.compTableSorting?.CONFIG_PARAMS[rootGetters['authModule/fullInstance']][comparableType] || [];

          return sortingOptions.filter((sortingOption) => {
            return sortingOption.Typologies.some((typology) => typology === propertyCode);
          });
        }
      };
    },

    getResearchCompListDefaultSortingOption(state, getters) {
      return (selectedTab) => {
        const sortingOptions = getters.getResearchCompListSortingOptions(selectedTab);
        return sortingOptions?.find((a) => a.IsDefault);
      };
    },

    // This returns the fields used to sort in front
    getFrontendSortingCriteria: (state) => (selectedTab) => {
      const sortField = state[selectedTab].researchBasketSortField || state.comparablesSortingField?.InternalField; // One is for the research module and the other for the property module. They never coexist
      const sortDirection = state[selectedTab].researchBasketSortDirection || state.comparablesSortingDirection; // One is for the research module and the other for the property module. They never coexist
      if (sortField && sortDirection) {
        return { sortFld: sortField, sortDir: sortDirection };
      } else {
        return null;
      }
    },

    // This returns the fields used to sort in backend
    getComparableSortList: (state, getters, rootState, rootGetters) => (selectedTab) => {
      const sortField = state[selectedTab].researchComparableSortField || state[selectedTab].sortField; // One is for the research module and the other for the property module. They never coexist
      const sortDirection = state[selectedTab].researchComparableSortDirection || state[selectedTab].sortDirection; // One is for the research module and the other for the property module. They never coexist
      const paramId = state[selectedTab].researchComparablesSortParamId ?? 0;
      const instanceRol = rootGetters['authModule/fullInstance'];
      if (sortField && sortDirection) {
        return [{ sortFld: sortField, sortDir: sortDirection, paramId, instanceRol }];
      } else {
        return [];
      }
    },

    getShowMore: (state) => (tab) => {
      return state[tab].showMore > state[tab].comparables?.length;
    },

    getBasket: (state) => (selectedTab) => {
      return state[selectedTab].basket;
    },

    getSearchZoneFigureType: (state) => (tab) => {
      return state[tab]?.zone?.figureType;
    },

    getSearchZoneFigure: (state) => (tab) => {
      return state[tab]?.zone?.figure;
    },

    getToggleStatus: (state) => (id, tab) => {
      return state[tab].status.toggleStatusList.find((item) => item.id === id);
    },

    getIncomeExpensesTableConfig: (state) => (propertyType) => {
      const tableConfig = state[genericTabConst.IE_COMPS].tableConfig;

      return tableConfig ? tableConfig.filter(({ Typology }) => Typology.split(' | ').includes(propertyType)).sort((a, b) => a.Typology - b.Typology || a.RowOrder - b.RowOrder) : [];
    },

    getDynamicFiltersList: (state) => (tab) => {
      return state[tab].filters.dynamicFiltersList;
    },

    getPopUpIsLoading: (state) => (tab) => {
      return state[tab].infoPopUp.isLoading;
    },
    getPopUpIsDual: (state) => (tab) => {
      return state[tab].infoPopUp.isDual;
    },
    getPopUpIsOpen: (state) => (tab) => {
      return state[tab].infoPopUp.isOpen;
    },
    getDisplayMapButtons: (state) => (selectedTab) => {
      return state[selectedTab].displayMapButtons;
    },
    getAutomaticSearchOnShapeChange: (state) => (selectedTab) => {
      return state[selectedTab].automaticSearchOnShapeChange;
    },

    getIsOpenOnPopUp: (state) => (comparableId, tab) => {
      return state[tab].infoPopUp.isOpen && state[tab].infoPopUp.comparableId === comparableId;
    },
    getInstanceToUnits(state, getters, rootState, rootGetters) {
      // Instance_US, Instance_UK, instance_CA -> miles (value of 2)
      // other -> meters (value of 1)
      // DistanceUnits 1 -> the distance of the comps to the subject property is measured in meters
      // DistanceUnits 2 -> the distance of the comps to the subject property is measured in miles
      const instancesInMiles = [fullInstanceConst.US, fullInstanceConst.UK];

      return instancesInMiles.includes(rootGetters['authModule/fullInstance']) ? unitsConst.MILES : unitsConst.METRES;
    },
    getSelectedSubTab: (state) => (selectedTab) => {
      return state[selectedTab]?.selectedSubTab ?? 0;
    },

    getGoToCommentSection: (state) => (selectedTab) => {
      return state[selectedTab]?.goToCommentSection ?? false;
    },

    getStaticColumnsConfig: (state) => (selectedTab) => {
      return state[selectedTab]?.staticColumnsConfig ?? [];
    },
    getSelectedTabFiltersStructure: (state) => (tab) => {
      return state[tab].filtersStructure;
    },
    getMapConfigIsLoaded: (state) => (tab) => {
      return state[tab].mapConfigIsLoaded;
    },
    getSelectedTabParsedFilters: (state) => (tab) => {
      return state[tab].filters?.flatMap(researchUtils.getParsedFilterValue);
    },
    getSelectedTabLocationFilter: (state) => (tab) => {
      return state[tab].filters.find(({ InternalField }) => InternalField === 'Location');
    },
    getSelectedTabProfilePage: (state) => (tab) => {
      return state[tab].profilePage;
    },
    getNewLeaseComparableID: (state) => (tab) => {
      return state[tab].newLeaseComparableID;
    },
  },
};

export default comparablesModule;

const createComparableModel = async function (
  { dispatch, getters },
  { countryCode, operationType, operationTypeId, langCode, propertyTypeCode, propertySubTypeCode, tableFeatures, priceOriginalMetric, location = {}, comparableHierLevel = 0, isNewParent = false, parentInfo = null, truncFeatures }
) {
  await dispatch('fetchGenericComparable');
  const emptyCompModel = getters.getGenericComparable;
  const id = crypto.randomUUID();

  return {
    ...emptyCompModel,
    id,
    CountryCode: countryCode,
    FileTypeID: 97,
    FileType: 'VAS_JLL',
    OperationType: operationType,
    OperationTypeID: operationTypeId,
    DefaultLanguage: langCode,
    PropertyTypeCode: propertyTypeCode,
    Id: id,
    RowId: id,
    ComparableID: new Date().getTime(),
    PropertyTypeList: [propertyTypeCode],
    PropertySubTypeList: [propertySubTypeCode],
    Latitude: location?.lat,
    Longitude: location?.lng,
    TableFeatures: tableFeatures,
    location: {
      coordinates: [location?.lng, location?.lat],
      type: 'Point',
    },

    // TODO this should be done by backend in the future this is a ñapa
    PriceOriginalMetric: priceOriginalMetric,
    // Set as comparable type CLOSING by default
    ComparableType: 'Closing',
    ComparableTypeID: 2,

    ComparableHierLevel: comparableHierLevel,
    IsNewParent: isNewParent,
    ParentInfo: parentInfo,
    ...truncFeatures,
  };
};
